import {
  FieldMappingSelectMulti,
  FieldMappingSelectMultiProps,
} from '@components/field-mapping-select-multi';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingSelectMultiProps<T = unknown> = FormFieldProps<
  FieldMappingSelectMultiProps,
  T
>;

export function FormFieldMappingSelectMulti<T>(props: FormFieldMappingSelectMultiProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping' });

  return <FieldMappingSelectMulti {...props} {...formFieldProps} />;
}
